<template>
  <!-- 债券信息 -->
  <div>
    <block>
      <div id="bondCount" style="position: relative;height: 0;overflow: hidden;top: -120px;"></div>
      <div class="table-list-title dis-bet-cen">
        <div>债券信息 <span style="color: #5D6FE9;">{{page.total}}</span></div>
      </div>
      <el-table
        border
        :data="TableData"
        :cell-style="cellStyle"
        :header-cell-style="headerColor"
        style="width: 100%;">
        <el-table-column type="index" width="50" label="序号"></el-table-column>
        <el-table-column v-for="(item,index) in tableHeader" :key="index" :label="item.label" :property="item.property" align="center">
          <template #default="scope">
            <el-button v-if="scope.column.property == 'handleImg'">预览</el-button>
            <el-button v-else-if="scope.column.property == 'handleDetails'">详情</el-button>
            <span v-else>{{scope.row[scope.column.property] || '-'}}</span>
          </template>
        </el-table-column>
        <el-table-column
            label="操作"
            width="80">
            <template #default="scope">
             <el-button type="text" @click="handleTo(scope.row)">详情</el-button>
            </template>
          </el-table-column>
      </el-table>
      <div class="table-page">
        <el-pagination
          background
          hide-on-single-page="true"
          :page-size="10"
          :pager-count="7"
          layout="prev, pager, next"
          v-model:currentPage="page.pageNum"
          @current-change="pageChange"
          :total="page.total">
        </el-pagination>
      </div>
      <el-dialog title="债券信息详情" :append-to-body="appendtobody" v-model="dialogTableVisible">
        <el-descriptions class="margin-top"  :column="2" :size="size" border>
          <el-descriptions-item :span="2">
            <template #label>债券名称</template>
            {{companyDetail.fullName || '-'}}
          </el-descriptions-item>
          <!-- <el-descriptions-item :span="1">
            <template #label>债券简称</template>
            {{companyDetail.shortName || '-'}}
          </el-descriptions-item> -->
          <el-descriptions-item :span="1">
            <template #label>债券代码</template>
            {{companyDetail.bondCode || '-'}}
          </el-descriptions-item>
          <el-descriptions-item :span="1">
            <template #label>债券类型</template>
            {{companyDetail.bondType || '-'}}
          </el-descriptions-item>
          <el-descriptions-item :span="1">
            <template #label>债券面值（元）</template>
            {{companyDetail.bondValue || '-'}}
          </el-descriptions-item>
          <el-descriptions-item :span="1">
            <template #label>债券年限（年）</template>
            <div>{{companyDetail.yearLimit || '-'}}</div>
          </el-descriptions-item>
          <el-descriptions-item :span="1">
            <template #label> 票面利率（%）</template>
            <div>{{companyDetail.interestRate || '-'}}</div>
          </el-descriptions-item>
          <el-descriptions-item :span="1">
            <template #label>到期日</template>
            <div>{{companyDetail.maturityDate || '-'}}</div>
          </el-descriptions-item>
          <!-- <el-descriptions-item :span="1">
            <template #label>兑付日</template>
            <div>{{companyDetail.payDate || '-'}}</div>
          </el-descriptions-item> -->
          <el-descriptions-item :span="1">
            <template #label>摘牌日</template>
            <div>{{companyDetail.delistDate || '-'}}</div>
          </el-descriptions-item>
          <!-- <el-descriptions-item :span="2">
            <template #label>利率说明</template>
            <div>{{companyDetail.rateIntroduce || '-'}}</div>
          </el-descriptions-item> -->
          <el-descriptions-item :span="1">
            <template #label>计息方式</template>
            <div>{{companyDetail.planBreathWay || '-'}}</div>
          </el-descriptions-item>
          <el-descriptions-item :span="1">
            <template #label>付息方式</template>
            <div>{{companyDetail.servicingWay || '-'}}</div>
          </el-descriptions-item>
          <el-descriptions-item :span="1">
            <template #label>起息日期</template>
            <div>{{companyDetail.payoutDate || '-'}}</div>
          </el-descriptions-item>
          <!-- <el-descriptions-item :span="1">
            <template #label>止息日期</template>
            <div>{{companyDetail.ceaseDate || '-'}}</div>
          </el-descriptions-item> -->
          <el-descriptions-item :span="1">
            <template #label>年付息次数</template>
            <div>{{companyDetail.annualInterestRate || '-'}}</div>
          </el-descriptions-item>
         <!-- <el-descriptions-item :span="1">
            <template #label>付息日期</template>
            <div>{{companyDetail.interestPaymentDate || '-'}}</div>
          </el-descriptions-item> -->
          <el-descriptions-item :span="1">
            <template #label>发行价格（元）</template>
            <div>{{companyDetail.offeringPrice || '-'}}</div>
          </el-descriptions-item>
          <el-descriptions-item :span="1">
            <template #label>发行规模（亿元）</template>
            <div>{{companyDetail.issuance || '-'}}</div>
          </el-descriptions-item>
          <el-descriptions-item :span="1">
            <template #label>发行日期</template>
            <div>{{companyDetail.releaseDate || '-'}}</div>
          </el-descriptions-item>
          <el-descriptions-item :span="1">
            <template #label>上市日期</template>
            <div>{{companyDetail.launchDate || '-'}}</div>
          </el-descriptions-item>
          <!-- <el-descriptions-item :span="1">
            <template #label>上市场所</template>
            <div>{{companyDetail.publicPlaces || '-'}}</div>
          </el-descriptions-item> -->
          <el-descriptions-item :span="1">
            <template #label>信用等级</template>
            <div>{{companyDetail.creditRating || '-'}}</div>
          </el-descriptions-item>
          <!-- <el-descriptions-item :span="1">
            <template #label>内部信用增级方式</template>
            <div>{{companyDetail.internalCreEnhMode || '-'}}</div>
          </el-descriptions-item> -->
          <!-- <el-descriptions-item :span="1">
            <template #label>外部信用增级方式</template>
            <div>{{companyDetail.externalCreEnhMode || '-'}}</div>
          </el-descriptions-item> -->
        </el-descriptions>
      </el-dialog>
    </block>
  </div>
</template>

<script>
import { forwardBG } from '@/api/forward.js'
export default {
  name: 'bond-count',
  props: { companyId: String },
  data () {
    return {
      appendtobody: true,
      companyDetail: {},
      dialogTableVisible: false,
      page: {
        total: 0,
        pageNum: 1
      },
      // 股东信息
      tableHeader: [{
        label: '债券代码',
        property: 'bondCode'
      }, {
        label: '债券类型',
        property: 'bondType'
      }, {
        label: '债券年限（年）',
        property: 'yearLimit'
      }, {
        label: '发行规模（亿元）',
        property: 'issuance'
      }, {
        label: '发行日期',
        property: 'releaseDate'
      }, {
        label: '上市日期',
        property: 'launchDate'
      }],
      TableData: []
    }
  },
  mounted () {
    this.initData()
  },
  methods: {
    handleTo (e) {
      this.dialogTableVisible = true
      const vm = this
      const data = {
        dateBackgroundUrl: '/BondDetail/getBondDetail',
        dateBackgroundRequestType: 'get',
        data: {
          id: e.id
        }
      }
      forwardBG(data).then(result => {
        if (result.code === 0) {
          const res = result.data
          res.releaseDate = res.releaseDate ? res.releaseDate.substring(0, 10) : '-'
          res.launchDate = res.launchDate ? res.launchDate.substring(0, 10) : '-'
          res.delistDate = res.delistDate ? res.delistDate.substring(0, 10) : '-'
          res.payDate = res.payDate ? res.payDate.substring(0, 10) : '-'
          res.maturityDate = res.maturityDate ? res.maturityDate.substring(0, 10) : '-'
          res.payoutDate = res.payoutDate ? res.payoutDate.substring(0, 10) : '-'
          res.ceaseDate = res.ceaseDate ? res.ceaseDate.substring(0, 10) : '-'
          vm.companyDetail = res
          console.log(res)
        }
      }).catch(error => {
        console.log(error)
      })
    },
    // 表格设置样式
    headerColor: function ({ row, column, rowIndex, columnIndex }) {
      return 'background-color:#E8EBFC;color:#666666;font-size:14px;text-align:center'
    },
    cellStyle: function ({ row, column, rowIndex, columnIndex }) {
      return 'text-align:center'
    },
    pageChange (e) {
      this.page.pageNum = e
      this.initData()
    },
    initData: function () {
      const vm = this
      const data = {
        dateBackgroundUrl: '/BondDetail/getBondList',
        dateBackgroundRequestType: 'get',
        data: {
          qccCompanyId: vm.companyId,
          pageNum: vm.page.pageNum,
          pageSize: 10
        }
      }
      forwardBG(data).then(result => {
        if (result.code === 0) {
          const res = result.data
          const arr = []
          vm.page.total = res.total
          res.list.forEach(item => {
            item.releaseDate = item.releaseDate ? item.releaseDate.substring(0, 10) : '-'
            item.launchDate = item.launchDate ? item.launchDate.substring(0, 10) : '-'
            arr.push(item)
          })
          vm.TableData = arr
        }
      }).catch(error => {
        console.log(error)
      })
    }
  }
}
</script>

<style scoped="scoped" lang="less">
.table-list-title {
  padding: 18px 0;
  text-align: left;
  color: #333;
  font-weight: bold;
}
.table-page {
  text-align: right;
  margin-top: 10px;
}
</style>
